
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import { createApp } from 'vue';
import { ZiggyVue, route } from '../../../vendor/tightenco/ziggy/dist';
import { Ziggy } from './ziggy';

import Alpine from 'alpinejs';
window.Alpine = Alpine;
document.addEventListener('DOMContentLoaded', () => Alpine.start());

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import DonationCollection from "./vue/accounts/donations/DonationCollection.vue";
import FeesCollection from "./vue/fees/collections/FeesCollection";
import CreateAccountRecords from "./vue/accounts/records/CreateAccountRecords";
import AddEditInvoice from "./vue/accounts/billing/AddEditInvoice";
import AddEditEximusInvoice from "./vue/accounts/billing/AddEditEximusInvoice";
import CreateExamRecord from "./vue/academics/exams/records/CreateExamRecord";
import LessonEvaluationRecord from "./vue/academics/lesson-evaluations/LessonEvaluationRecord";
import EditEmployeeShifts from "./vue/hr/attendance/employee-shifts/EditEmployeeShifts";
import AddPurchase from "./vue/inventory/purchases/AddPurchase.vue";
import CreateMcq from "./vue/academics/mcq/CreateMcq.vue";
import OnlineApplicationHscForm from "./vue/hr/online-application-hsc/OnlineApplicationHscForm";
import CreateDailyLessons from "./vue/academics/daily-lessons/CreateDailyLessons.vue";
import StudentCounts from "./vue/hr/students/StudentCounts.vue";

window.app = createApp({
    components: {
        DonationCollection,
        FeesCollection,
        CreateAccountRecords,
        AddEditInvoice,
        AddEditEximusInvoice,
        CreateExamRecord,
        LessonEvaluationRecord,
        EditEmployeeShifts,
        AddPurchase,
        CreateMcq,
        OnlineApplicationHscForm,
        CreateDailyLessons,
        StudentCounts
    }
}).use(ZiggyVue, Ziggy);

// Make window object available to all components as global property
app.config.globalProperties.window = window;

window.route = (routeName, params) => route(routeName, params, null, Ziggy);

require('./main');

document.addEventListener('DOMContentLoaded', () => {
    window.editor.render()
});
